module.exports = __webpack_public_path__ + "epilace_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/epilace_2_after.jpg
// module id = 945
// module chunks = 0